import {deserializeAs} from "cerialize";

export class ActiveConsumptionPeriod {
  @deserializeAs('id')
  public id: number = null;

  @deserializeAs(Date, 'start_date_period')
  public startDatePeriod: Date = null;

  @deserializeAs(Date, 'end_date_period')
  public endDatePeriod: Date = null;
}
